import React from "react";
import ReactDOM from "react-dom";
import "./app/index.css";
import "./app/assets/fonts/fonts.css";
import App from "./app/App";

ReactDOM.render(<App />, document.getElementById("root"));
